import jwtDecode from "jwt-decode";
import React, { createContext, useState, useEffect } from "react";
import { role } from "../axious";
import { postMethodPermission } from "../services/httpServices";
import { accessMenu, accessOne } from "./config";
import axios from "axios";
import { toast } from "react-toastify";

const Context = createContext("Default Value");

export function ContextProvider(props) {
  const [userAccess, setUserAccess] = useState(null);
  const [menu, setMenu] = useState(null);
  const [jwt, setJwt] = useState(localStorage.getItem("token"));
  const [isShowEditor, setIsShowEditor] = useState(false);
  const api1 = "https://api.hazecrypto.net/Api/Admin/Audit";
  const token = jwt;

  const getAudits = async () => {
    try {
      const { data: audits } = await axios.get(api1, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return audits;
    } catch (error) {
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  const api = "https://api.hazecrypto.net/Api/Admin/";

  const getMethodPagination = async (route, page) => {
    const { data: collection } = await axios.get(api + route, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        page: page,
      },
    });
    return collection;
  };
  const getMethodPaginationWithFilter = async (route, page, filter) => {
    toast.dismiss();
    try {
      const { data: collection } = await axios.get(api + route, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page: page,
          status: filter,
        },
      });
      return collection;
    } catch (error) {
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  const getMethod = async (route) => {
    toast.dismiss();
    try {
      const { data: collection } = await axios.get(api + route, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return collection;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  const getMethodSearch = async (
    route,
    searchQuery,
    searchType,
    statusType,
    dateType
  ) => {
    toast.dismiss();
    try {
      const { data: collection } = await axios.get(api + route + searchQuery, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          searchBy: searchType,
          status: statusType,
          dateBy: dateType,
        },
      });
      return collection;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  const putMethod = async (route, id, content) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route + id, content, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };
  const putMethodSettings = async (route, content) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route, content, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  const putMethodFormData = async (route, id, content) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route + id, content, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
      });
      return response;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  const postMethod = async (route, content) => {
    toast.dismiss();
    try {
      const response = await axios.post(api + route, content, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };
  const postMethodPermission = async (route, id) => {
    toast.dismiss();
    try {
      const response = await axios.post(
        api + route + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };
  const postMethodNormal = async (route, content) => {
    toast.dismiss();
    try {
      const response = await axios.post(api + route, content, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log("error", error);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };
  const deleteMethod = async (route, id) => {
    toast.dismiss();
    try {
      const response = await axios.put(api + route + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };
  const deleteMethod2 = async (route, id) => {
    toast.dismiss();
    try {
      const response = await axios.delete(api + route + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response;
    } catch (error) {
      error &&
        error.response &&
        error.response.data &&
        error.response.data.Message &&
        toast(error.response.data.Message);
      error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.map((e) => toast(e.msg));
    }
  };

  useEffect(() => {
    try {
      const user = jwt ? jwtDecode(jwt) : null;
      user &&
        axios
          .post(
            api + role.check + user.id,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            setUserAccess(response.data.Message.Role);
          })
          .catch((error) => console.log("error: ", error));
    } catch (error) {
      console.log("Error: ", error);
    }
  }, [jwt]);

  useEffect(() => {
    try {
      const menuList = userAccess ? accessMenu(userAccess) : null;
      userAccess && menuList && setMenu(menuList);
    } catch (error) {
      console.log("Error: ", error);
    }
  }, [userAccess]);

  const context = {
    userAccess,
    menu,
    jwt,
    setJwt,
    getAudits,
    getMethodPagination,
    getMethodPaginationWithFilter,
    getMethod,
    getMethodSearch,
    putMethod,
    putMethodSettings,
    putMethodFormData,
    postMethod,
    postMethodPermission,
    postMethodNormal,
    deleteMethod,
    isShowEditor,
    setIsShowEditor,
    deleteMethod2,
  };
  return <Context.Provider value={context}>{props.children}</Context.Provider>;
}

export default Context;



// WEBPACK FOOTER //
// ./src/store/Context.js